import RichTextEditor from './RichTextEditor';
import '../styles/richtext-editor.css';

interface ContentEditorWithPreviewProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  label?: string;
  required?: boolean;
}

export default function ContentEditorWithPreview({
  value,
  onChange,
  placeholder,
  label,
  required,
}: ContentEditorWithPreviewProps) {
  return (
    <div>
      {label && (
        <label className="field-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}

      <RichTextEditor
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
}
